/**
 * @generated SignedSource<<279e8c44474c242bde0c4d24f6266253>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SalesChannelStatus = "ACTIVE" | "DISABLED";
export type salesChannelSetStatusMutation$variables = {
  id: string;
  status: SalesChannelStatus;
};
export type salesChannelSetStatusMutation$data = {
  readonly setSalesChannelStatus: {
    readonly id: string;
  } | null;
};
export type salesChannelSetStatusMutation = {
  response: salesChannelSetStatusMutation$data;
  variables: salesChannelSetStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "SalesChannel",
    "kind": "LinkedField",
    "name": "setSalesChannelStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelSetStatusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "salesChannelSetStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dfdfcf34fcc7fa2e9093812559463856",
    "id": null,
    "metadata": {},
    "name": "salesChannelSetStatusMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelSetStatusMutation(\n  $id: ID!\n  $status: SalesChannelStatus!\n) {\n  setSalesChannelStatus(id: $id, status: $status) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "56eed9cb859b8684fffdf93071d2fdd2";

export default node;
